export const MIN_NUMBER_OF_PRINTS = 10;
export const NO_PRINTS = 0;
export const STEP = 1;
export const PRINT_NUMBER_PROMO = 1;
export const FORBIDDEN_NUMBER_OF_PRINTS = 5;
